import { useQuery } from "@tanstack/react-query";
import { REQUEST_HH_QUERY_KEYS } from "../../constants";
import { getFilters } from "@src/entities/requestHH/api/requests/getFilters";

export const useGetFilters = () => {
  const query = useQuery({
    queryKey: [REQUEST_HH_QUERY_KEYS.getFilters],
    queryFn: () => getFilters(),
  });

  return query;
};
